<template>
  <section class="folderlist">
      <section class="favourites" v-if="$store.getters.favouriteFolders.length">
          <folder-favourites :favouriteFolders="$store.getters.favouriteFolders"
                             :selectedType="selectedType" :selectedFolder="selectedFolder"
                             @select="$emit('select', $event)"></folder-favourites>
      </section>

      <div class="foldertree">
          <ul>
              <folder-tree :folder="rootFolders" :selectedType="selectedType" :selectedFolder="selectedFolder"
                           @select="$emit('select', $event)"></folder-tree>
          </ul>
      </div>
  </section>
</template>

<script>
import FolderTree from '@/components/folderTree';
import FolderFavourites from '@/components/folderFavourites';

export default {
  name: 'folderList',
  components: { FolderTree, FolderFavourites },
  props: {
    // folders: Object,
    foldertype: String,
    folderid: String

  },
  mounted() {
    console.log('mounted folder tree', this.folders);
  },
  computed: {
    folders() {
      return this.$store.state.folders;
    },
    rootFolders() {
      const folders = this.folders;
      return folders;
    },
    selectedType() {
      if (this.foldertype === 'f') {
        return 'F';
      } else {
        return '';
      }
    },
    selectedFolder() {
      console.log('selected Folder', this.selectedType, this.folderid);
      return parseInt(this.folderid, 10);
    }
  }
};
</script>

<style scoped lang="scss">
@import '../assets/bootstrap-style.scss';
    .folderlist {
        display: flex;
        flex-direction: column;
        height: 100%;

        .favourites {
            flex: 0 0 auto;
            padding-bottom: 5px;
            border-bottom: 1px solid $gray-400;
            margin-bottom: 5px;
            margin-right: 18px;
        }
    }
    div.foldertree {
        flex: 1;
        overflow-y: scroll;
        ul {
            padding-left: 0px;
            list-style: none;
            margin-block-end: 0;
        }
    }
</style>
